import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Stack,
  Container,
  Button,
  SvgIcon,
} from "@mui/material";
import useConfirm from "../../../hooks/useConfirm";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { Scrollbar } from "../components/scrollbar";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { ROUTES } from "../../../constants";
import { useNavigate } from "react-router-dom";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { TableCellIconStyles } from "../../../styles/theme";
import { Referee } from "../../../types/types";
import { removeReferee, setEditingReferee } from "../../../features/referees/refereesSlice";
import NotificationService from "../../../components/notification/NotificationService";
import { dbDeleteReferee } from "../../../api/api";


export const Referees = () => {
  const [Dialog, confirmDelete] = useConfirm(
    "Er du sikker?",
    `Er du sikker på at du vil slette denne dommer? `
  );

  const referees = useAppSelector(state => state.referees.referees)
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const matches = useAppSelector(state => state.matches.groupMatches);

  const editRefereeHandler = (referee: Referee) => {
    dispatch(setEditingReferee(referee));
    navigate(ROUTES.ADMIN_CREATE_REFEREE);
  };

  const deleteRefereeHandler = async (refereeId: string, refereeName: string) => {
    // Check if any matches are using the referee first!

    const matchesUsingReferee = matches.filter((match) => match.referees.some(ref => ref.referee.id === refereeId));

    if (matchesUsingReferee.length > 0) {
      NotificationService.showToast({
        severity: "error",
        text: `${matchesUsingReferee.length === 1 ? '1 kamp' : `${matchesUsingReferee.length} kampe`} bruger denne dommer.`,
        duration: 5000,
      });
      return;
    }

    const confirmed = await confirmDelete();
    if (confirmed) {
      dbDeleteReferee(refereeId)
        .then(() => {
          dispatch(removeReferee(refereeId));
          NotificationService.showToast({
            severity: "success",
            text: `Dommeren blev slettet`,
            duration: 5000,
          });
        })
        .catch((e) => {
          console.error(e);
          NotificationService.showToast({
            severity: "error",
            text: `Dommeren kunne ikke slettes.`,
            duration: 5000,
          });
        });
    }
  };


  return (
    <>
      {Dialog()}
      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Dommere</Typography>
            <div>
              <Button
                startIcon={
                  <SvgIcon fontSize="small">
                    <PlusIcon />
                  </SvgIcon>
                }
                variant="contained"
                onClick={() => navigate(ROUTES.ADMIN_CREATE_REFEREE)}
              >
                Opret
              </Button>
            </div>
          </Stack>
          <Card>
            <Scrollbar>
              <Box sx={{ minWidth: 300 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Navn</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {referees
                      .map((referee, i) => {
                        return (
                          <TableRow hover key={referee.id}>
                            <TableCell>{referee.name}</TableCell>
                            <TableCell
                              sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "40px" }}
                            >
                              <ModeEditOutlineOutlinedIcon
                                sx={TableCellIconStyles}
                                onClick={() => editRefereeHandler(referee)}
                              />
                              <DeleteOutlineOutlinedIcon
                                sx={TableCellIconStyles}
                                onClick={() => deleteRefereeHandler(referee.id, referee.name)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Box>
            </Scrollbar>
          </Card>
        </Stack>
      </Container>
    </>
  );
};
